import React, { useState } from 'react';
import MaterialCard from '../MaterialCard';
import SectionCard from '../SectionCard';
import SectionBanner from '../SectionBanner';
import ManagerPopup from '../ManagerPopup';
import './HomeTab.css';

const HomeTab = ({ 
  appData, 
  onToggleFavorite, 
  selectedSection, 
  onSectionSelect, 
  onBackToSections 
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  
  if (!appData) return null;

  // Фильтруем разделы, исключая раздел чатов по shortname
  const sections = appData.sections.filter(section => 
    section.shortname !== 'chats'
  );

  

  // Если выбран раздел, показываем материалы
  if (selectedSection) {
    return (
      <div className="home-tab">
        <div className="section-header">
          <h2>{selectedSection.title}</h2>
        </div>
        {selectedSection.materials && selectedSection.materials.length > 0 ? (
          <div className="materials-grid">
            {selectedSection.materials.map(material => (
              <MaterialCard
                key={`${selectedSection.id}-${material.id}`}
                material={material}
                onToggleFavorite={onToggleFavorite}
                appData={appData}
              />
            ))}
          </div>
        ) : (
          <div className="no-materials">
            <p>В этом разделе пока нет материалов</p>
          </div>
        )}
      </div>
    );
  }

  // Показываем список разделов
  const showBanner = appData.configs?.show_section_banner === "true";
  const supportLink = appData.configs?.support_link;
  
  const handleBannerClick = () => {
    setIsPopupOpen(true);
  };
  
  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };
  
  return (
    <div className="home-tab">
      <div className="section-header">
        <h2>Основной материал</h2>
      </div>
      {showBanner && (
        <SectionBanner onClick={handleBannerClick} />
      )}
      <div className="sections-grid">
        {sections.map(section => (
          <SectionCard
            key={section.id}
            section={section}
            onClick={() => onSectionSelect(section)}
          />
        ))}
      </div>
      
      <ManagerPopup
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
        supportLink={supportLink}
      />
    </div>
  );
};

export default HomeTab; 